import React from "react";
import { FiltersTypes } from "@common/types/filters/general";
import { ruleActionDisplayLabels } from "@components/pageHeader/filters/lib";
import { formatFilterLabelText } from "./formatFilterLabel";

interface Props {
    filters: Pick<FiltersTypes, "ruleActionTypes">;
}

export const RulesActionFilterLabel: React.FC<Props> = ({
    filters: { ruleActionTypes },
}) => (
    <>
        {formatFilterLabelText(
            (ruleActionTypes ?? []).map(
                (actionType) => ruleActionDisplayLabels[actionType],
            ),
            "Actions",
        ) ?? "All"}
    </>
);
